// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3ilHO","title":"card_title__3DnWG","inActive":"card_inActive__3IM6J"};